module.exports = __webpack_public_path__ + "static/media/IMG_3032.67857d2e.JPG";